// extracted by mini-css-extract-plugin
export default {"starContainer":"RatingStar_starContainer__F2Wkm","animation":"RatingStar_animation__v-qz9"};